<template>
  <div class="w-100 text-center">
    <div v-if="hidePrices">
      <BushelBtn class="px-3 py-1" variant="dark" outline @click="$emit('contactButtonClicked')"> Please Inquire For Price </BushelBtn>
    </div>
    <div v-else-if="selectedBatch && selectedBatch.id">
      <h3 class="font-weight-bold text-white">
        <span class="rounded-pill px-3 py-1 bg-header-text-color">
          <span v-if="product.category.name != 'Pack To Order'">
            <span v-if="selectedBatch.tiered_listing_price">
              <del class="text-danger small mr-2">{{ currency(selectedBatch.listing_price) }}</del>
              <span class="d-inline-block">{{ currency(selectedBatch.tiered_listing_price) }}</span>
              <span
                v-if="product.unit_measurement && product.unit_measurement.alias"
                class="d-inline-block text-smallest font-weight-light"
                style="top: -5px; position: relative"
              >
                / {{ getUnit(product, true).name }}
              </span>
            </span>
            <span v-else>
              {{ currency(selectedBatch.listing_price) }}
              <span
                v-if="product.unit_measurement && product.unit_measurement.alias"
                class="d-inline-block text-smallest font-weight-light"
                style="top: -5px; position: relative"
              >
                / {{ getUnit(product, true).name }}
              </span>
            </span>
          </span>
          <span v-else>
            <!-- <span class="m-0">
              ${{ countDecimals(ptoGetMinPrice(product) / 100) > 0 ? (ptoGetMinPrice(product) / 100).toFixed(2) : ptoGetMinPrice(product) / 100 }}
            </span>
            <span v-if="ptoGetMaxPrice(product) != ptoGetMinPrice(product)" class="m-0"
              >- ${{ countDecimals(ptoGetMaxPrice(product) / 100) > 0 ? (ptoGetMaxPrice(product) / 100).toFixed(2) : ptoGetMaxPrice(product) / 100 }}
            </span> -->
            Variable / Gram
          </span>
        </span>
      </h3>
      <div class="">
        <span
          v-for="value in getUnitMeasurementPriceBreakdown(product, selectedBatch)"
          :key="value"
          class="badge badge-secondary border mr-1 text-small"
        >
          {{ value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getUnit, ptoGetMinPrice, ptoGetMaxPrice, getUnitMeasurementPriceBreakdown } from "@/services/storefront/storefront";
import { currency } from "@/services/filters";

export default {
  props: {
    product: { type: Object, required: true },
    hidePrices: { type: Boolean, required: true },
    selectedBatch: { type: Object, required: true },
    selectedProduct: { type: Object, default: null },
  },
  emits: ["contactButtonClicked"],
  methods: {
    getUnit,
    ptoGetMinPrice,
    ptoGetMaxPrice,
    getUnitMeasurementPriceBreakdown,
    currency,
    countDecimals(value) {
      if (value % 1 != 0) {
        return value.toString().split(".")[1].length;
      }
      return 0;
    },
  },
};
</script>
